import React from 'react';
import { Info } from 'lucide-react';
import { SUBSCRIPTION_METRICS } from '../../data/ipoSubscriptionData';

const DOT_TONES = ['bg-sky-500', 'bg-[#008080]', 'bg-emerald-500', 'bg-violet-500', 'bg-amber-500', 'bg-rose-500'];

export const SubscriptionMetricsGuide = ({
  title = 'Understanding Subscription Metrics & Categories',
  metrics = SUBSCRIPTION_METRICS,
}) => (
  <section aria-labelledby="metrics-guide-heading" className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-5 sm:p-7">
    <h2 id="metrics-guide-heading" className="flex items-center gap-2 text-base sm:text-lg font-extrabold text-slate-900 tracking-tight">
      <Info className="w-4 h-4 text-[#008080]" />
      {title}
    </h2>
    <ul className="mt-5 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      {metrics.map((metric, index) => (
        <li key={metric.title} className="rounded-xl border border-slate-200 bg-slate-50/50 p-4">
          <h3 className="flex items-center gap-2 text-sm font-extrabold text-slate-900">
            <span className={`w-2 h-2 rounded-full ${DOT_TONES[index % DOT_TONES.length]}`} aria-hidden="true" />
            {metric.title}
          </h3>
          <p className="mt-2 text-xs text-slate-600 leading-relaxed">{metric.body}</p>
        </li>
      ))}
    </ul>
  </section>
);

export default SubscriptionMetricsGuide;
